import folderClosedSvg from '@/assets/folder-closed.svg';
import selectionIconSvg from '@/assets/selection-icon.svg';
import childSelectionMenuIconSvg from '@/assets/child-selection-menu-icon.svg';
import lineChartIconSvg from '@/assets/line-chart-icon.svg';
import pieChartIconSvg from '@/assets/pie-chart-icon.svg';
import barChartIconSvg from '@/assets/bar-chart-icon.svg';
import listIconSvg from '@/assets/list-icon.svg';
import cloneIconSvg from '@/assets/clone-icon.svg';
import menuActionsIconSvg from '@/assets/menu-actions-icon.svg';
import addToReportIconSvg from '@/assets/add-to-report-icon.svg';
import projectionIconSvg from '@/assets/projection-icon.svg';
import heartSvg from '@/assets/heart.svg';
import heartActiveSvg from '@/assets/heart-active.svg';
import selectElementIconSvg from '@/assets/select-element-icon.svg';
import infoCircleSvg from '@/assets/info-circle.svg';
import copyLinkIconSvg from '@/assets/copy-link-icon.svg';
import iconDeleteSvg from '@/assets/icon-delete.svg';
import projectionToClientsIconSvg from '@/assets/projection-to-clients-icon.svg';
import projectionToProjectsIconSvg from '@/assets/projection-to-projects-icon.svg';
import projectionToJobsIconSvg from '@/assets/projection-to-jobs-icon.svg';
import projectionToFilesIconSvg from '@/assets/projection-to-files-icon.svg';
import projectionToPositionsIconSvg from '@/assets/projection-to-positions-icon.svg';
import projectionToMovementsIconSvg from '@/assets/projection-to-movements-icon.svg';

export const ContextMenuIcons = {
  Folder: folderClosedSvg,
  Selection: selectionIconSvg,
  ChildSelection: childSelectionMenuIconSvg,
  LinearChart: lineChartIconSvg,
  PieChart: pieChartIconSvg,
  BarChart: barChartIconSvg,
  List: listIconSvg,
  Clone: cloneIconSvg,
  Actions: menuActionsIconSvg,
  AddToReport: addToReportIconSvg,
  Projection: projectionIconSvg,
  Heart: heartSvg,
  HeartActive: heartActiveSvg,
  SelectElement: selectElementIconSvg,
  Info: infoCircleSvg,
  CopyLink: copyLinkIconSvg,
  Delete: iconDeleteSvg,
} as const;

export const PROJECTION_SUBMENU_ICONS: Record<number, string> = {
  0: projectionToProjectsIconSvg,
  1: projectionToClientsIconSvg,
  2: projectionToJobsIconSvg,
  4: projectionToFilesIconSvg,
  7: projectionToPositionsIconSvg,
  8: projectionToMovementsIconSvg,
};

export function childSelectionMenuIcon(elType: number): string {
  return elType === 7 ? selectionIconSvg : childSelectionMenuIconSvg;
}
